/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { ReactNode } from 'react';
import { checkUrl } from '../utilities/checkUrl';

export interface SectionDataProps {
  cols?: string;
  label: string;
  value?: number | boolean | string;
  tryRenderAsLink?: boolean;
}

export default function SectionData({ cols, label, value, children, tryRenderAsLink }: SectionDataProps & { children?: ReactNode }) {
  if (!cols) {
    cols = '';
  }
  return (
    <div className={'section-data ' + cols}>
      <span className="label">{label}</span>
      {tryRenderAsLink && value ? (checkUrl(String(value)) ? <a href={String(value)}>{value}</a> : value)
        : <span className="value" style={{ whiteSpace: 'pre-line' }}>{children || String(value)}</span>}
    </div>
  );
}
